import { render, staticRenderFns } from "./KCheckbox.vue?vue&type=template&id=cb50ad20&scoped=true&"
import script from "./KCheckbox.vue?vue&type=script&lang=js&"
export * from "./KCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./KCheckbox.vue?vue&type=style&index=0&id=cb50ad20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb50ad20",
  null
  
)

export default component.exports